import React from "react"

type Row = {
  tipo: string
  tipoGafete: string
  caras: number
  boletos: number | "N/A"
}

type Group = {
  color: `#${string}`
  rows: Row[]
}

// Util: decide texto blanco o negro según el fondo
const getTextColor = (hex: string) => {
  const c = hex.replace("#", "")
  const r = parseInt(c.substring(0, 2), 16)
  const g = parseInt(c.substring(2, 4), 16)
  const b = parseInt(c.substring(4, 6), 16)
  // YIQ
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 140 ? "#111827" : "#ffffff"
}

const DATA: Group[] = [
  {
    color: "#1F7B5C",
    rows: [
      { tipo: "Residente FEMECOT", tipoGafete: "RESIDENTE", caras: 2, boletos: "N/A" },
      { tipo: "Residente Internacional", tipoGafete: "RESIDENTE", caras: 2, boletos: "N/A" },
      { tipo: "Residente NO FEMECOT", tipoGafete: "RESIDENTE", caras: 2, boletos: "N/A" },
      { tipo: "Estudiante", tipoGafete: "RESIDENTE", caras: 2, boletos: "N/A" },
    ],
  },
  {
    color: "#501168",
    rows: [
      { tipo: "Ortopedista FEMECOT", tipoGafete: "CONGRESISTA", caras: 4, boletos: 5 },
      { tipo: "Ortopedista NO FEMECOT", tipoGafete: "CONGRESISTA", caras: 4, boletos: 5 },
      { tipo: "Ortopedista CMO", tipoGafete: "CONGRESISTA", caras: 4, boletos: 5 },
    ],
  },
  {
    color: "#CA7C34",
    rows: [
      { tipo: "Ortopedista Internacional FEMECOT", tipoGafete: "CONGRESISTA", caras: 2, boletos: "N/A" },
      { tipo: "Ortopedista Internacional NO FEMECOT", tipoGafete: "CONGRESISTA", caras: 2, boletos: "N/A" },
      { tipo: "Ortopedista IOTA", tipoGafete: "CONGRESISTA", caras: 2, boletos: "N/A" },
    ],
  },
  {
    color: "#000066",
    rows: [
      { tipo: "Enfermería", tipoGafete: "CONGRESISTA", caras: 2, boletos: "N/A" },
      { tipo: "Fisioterapeuta / Lic. en Rehabilitación", tipoGafete: "CONGRESISTA", caras: 2, boletos: "N/A" },
      { tipo: "Médico No Ortopedista", tipoGafete: "CONGRESISTA", caras: 2, boletos: "N/A" },
    ],
  },
  {
    color: "#D54125",
    rows: [{ tipo: "Expositor / Acceso Comercial", tipoGafete: "EXPOSITOR", caras: 2, boletos: "N/A" }],
  },
  {
    color: "#33CC33",
    rows: [{ tipo: "Espectador Comercial", tipoGafete: "ESPECTADOR COMERCIAL", caras: 2, boletos: "N/A" }],
  },
  {
    color: "#FFCC00",
    rows: [{ tipo: "Staff", tipoGafete: "STAFF", caras: 2, boletos: "N/A" }],
  },
  {
    color: "#03193F",
    rows: [{ tipo: "Profesor IOTA", tipoGafete: "PROFESOR", caras: 2, boletos: "N/A" }],
  },
  {
    color: "#941012",
    rows: [
      { tipo: "Profesor FEMECOT", tipoGafete: "PROFESOR", caras: 2, boletos: "N/A" },
      { tipo: "Profesora FEMECOT", tipoGafete: "PROFESOR", caras: 2, boletos: "N/A" },
      { tipo: "PONENTE", tipoGafete: "PROFESOR", caras: 2, boletos: "N/A" },
    ],
  },
]

const ColorCell: React.FC<{ hex: string; rowSpan: number }> = ({ hex, rowSpan }) => (
  <td
    rowSpan={rowSpan}
    className="border px-3 py-2 text-center font-mono align-middle"
    style={{ backgroundColor: hex, color: getTextColor(hex) }}
    title={hex}
  >
    {hex}
  </td>
)

const Th: React.FC<React.PropsWithChildren> = ({ children }) => (
  <th className="border px-3 py-2 text-left">{children}</th>
)

const Td: React.FC<React.PropsWithChildren<{ center?: boolean }>> = ({ children, center }) => (
  <td className={`border px-3 py-2 ${center ? "text-center" : ""}`}>{children}</td>
)

export const BadgeColorTable: React.FC = () => {
  return (
    <div className="border rounded-lg bg-white shadow-sm mt-2">
      <div className="overflow-x-auto">
        <table className="min-w-full border text-sm text-gray-700">
          <thead className="bg-gray-100">
            <tr>
              <Th>Tipo de Gafete</Th>
              <Th>Tipo</Th>
              <Th>Color de Gafete</Th>
              <Th>Cantidad de caras</Th>
              <Th>Boletos para rifas</Th>
            </tr>
          </thead>

          <tbody>
            {DATA.map((group, gi) =>
              group.rows.map((r, ri) => (
                <tr key={`${gi}-${ri}`} className="even:bg-gray-50">
                  <Td>{r.tipo}</Td>
                  <Td>{r.tipoGafete}</Td>

                  {ri === 0 && <ColorCell hex={group.color} rowSpan={group.rows.length} />}

                  <Td center>{r.caras}</Td>
                  <Td center>{r.boletos}</Td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default BadgeColorTable
